module.exports = __webpack_public_path__ + "3357c98e572739aa4e01290d0ce1c2e7.png";